import Clarity from "@microsoft/clarity"
import { CLARITY_PROJECT_ID } from "gatsby-env-variables"

const LOG_PREFIX = "[Clarity]"

const isClarityDebug =
  typeof process !== "undefined" && process.env && process.env.NODE_ENV === "development"

function clarityDebug(...args) {
  if (isClarityDebug) {
    // eslint-disable-next-line no-console
    console.log(LOG_PREFIX, ...args)
  }
}

/** En desarrollo, registra la primera petición de red hacia clarity.ms (p. ej. collect). */
function observeClarityNetworkOnce() {
  if (!isClarityDebug || typeof window === "undefined" || typeof PerformanceObserver === "undefined") {
    return
  }
  let collectSeen = false
  try {
    const observer = new PerformanceObserver(list => {
      for (const entry of list.getEntries()) {
        const name = entry.name || ""
        if (!name.includes("clarity.ms")) continue
        if (name.includes("v.clarity.ms/collect") && !collectSeen) {
          collectSeen = true
          clarityDebug("Petición de recolección detectada (beacon):", name)
        } else if (name.includes("/tag/")) {
          clarityDebug("Script / recurso Clarity:", name)
        }
      }
    })
    observer.observe({ type: "resource", buffered: true })
  } catch {
    /* PerformanceObserver no disponible */
  }
}

/**
 * Carga el tag de Clarity y concede almacenamiento analítico.
 * Sin integración con Application Insights: solo Microsoft Clarity.
 * @see https://www.npmjs.com/package/@microsoft/clarity
 */
const initClarity = () => {
  if (typeof window === "undefined" || !CLARITY_PROJECT_ID) {
    clarityDebug("init omitido: sin window o CLARITY_PROJECT_ID vacío")
    return
  }

  const projectId = String(CLARITY_PROJECT_ID).trim()
  if (!projectId) {
    clarityDebug("init omitido: projectId vacío")
    return
  }

  clarityDebug("Inicializando proyecto:", projectId)
  observeClarityNetworkOnce()

  Clarity.init(projectId)
  Clarity.consentV2({
    ad_Storage: "granted",
    analytics_Storage: "granted",
  })
  clarityDebug("init + consentV2(analytics) aplicados")

  window.setTimeout(() => {
    const scriptEl = document.getElementById("clarity-script")
    clarityDebug("Comprobación post-carga:", {
      scriptTagPresente: Boolean(scriptEl),
      windowClarityType: typeof window.clarity,
    })
  }, 1500)
}

const identifyUser = (userId, userHint) => {
  if (typeof window === "undefined" || !CLARITY_PROJECT_ID || !userId) return
  Clarity.identify(userId, undefined, undefined, userHint || undefined)
  clarityDebug("identify llamado (usuario hasheado en Clarity)")
}

const trackEvent = (eventName, detail) => {
  if (typeof window === "undefined" || !CLARITY_PROJECT_ID || !eventName) return
  Clarity.event(detail != null && detail !== "" ? `${eventName}:${detail}` : eventName)
}

export default { initClarity, identifyUser, trackEvent }
